import { UnidadSolicitud } from './unidad-solicitud';

export class ServiceDetails {
  Id: number;
  ID_TIPO_SERVICIO: number;
  ID_CREADOR: number;
  ID_SOLICITANTE: number;
  ID_SERIE: number;
  ID_ESTADO_SERVICIO: number;
  ID_DIRECCION: number;
  FECHA_CREACION: string;
  FECHA_SOLICITUD: string;
  FECHA_FINALIZACION: string;
  FECHA_SLA: string;
  EMAIL: string;
  NORMAL_URGENTE: string;
  MANUAL_MASIVA: string;
  COD_SERVICIO_CLIENTE: string;
  CECO: string;
  FORMATO_PRESTAMO: string;
  ID_PROVEEDOR: number;
  constructor() { }
}

export class SolicitudServicio {

  unidades: UnidadSolicitud[] = [];

  detalle = new ServiceDetails();

  constructor() { }

}
